import { ChangeDetectionStrategy, Component, booleanAttribute, computed, input } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

/**
 * The box in a list of things that are either included or not — a facet, a branch of a tree. Both
 * the glyph and its tint live here, which is what stops one list from ticking a different colour
 * than the one beside it.
 *
 * Not an `<input type="checkbox">`: the whole row is the control, and the row is a button.
 */
@Component({
  selector: 'guarantees-check-box',
  standalone: true,
  imports: [MatIcon],
  host: { class: 'contents' },
  template: `<mat-icon class="h-4! w-4! shrink-0 text-base! leading-4!" [class]="toneClass()">{{ checked() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckBoxComponent {
  checked = input(false, { transform: booleanAttribute });

  protected readonly toneClass = computed(() => (this.checked() ? 'text-primary-600' : 'text-neutral-300'));
}

/** The button a checkable row sits in, so every such row has the same hit area and hover. */
export const CHECK_ROW_CLASS =
  'flex min-w-0 items-center gap-2 rounded-lg px-1.5 py-1.5 text-left text-sm transition-colors duration-150 hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none';
